import { unique } from "../../util";
import { $push } from "./push";
/**
 * Returns an array of all the unique values for the selected field among for each document in that group.
 *
 * @param {Array} collection The input array
 * @param {Object} expr The right-hand side expression value of the operator
 * @param {Options} options The options to use for this operation
 * @returns {*}
 */
export const $addToSet = (collection, expr, options) => {
    return unique($push(collection, expr, options), options === null || options === void 0 ? void 0 : options.hashFunction);
};
